export default __webpack_public_path__ + "static/media/logo.17fe550d.png";